import { render, staticRenderFns } from "./RandomGroup.vue?vue&type=template&id=9c836d26&scoped=true"
import script from "./RandomGroup.vue?vue&type=script&lang=js"
export * from "./RandomGroup.vue?vue&type=script&lang=js"
import style0 from "./RandomGroup.vue?vue&type=style&index=0&id=9c836d26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c836d26",
  null
  
)

export default component.exports